import { render, staticRenderFns } from "./msg403.vue?vue&type=template&id=02468d88&scoped=true&"
import script from "./msg403.vue?vue&type=script&lang=js&"
export * from "./msg403.vue?vue&type=script&lang=js&"
import style0 from "./msg403.vue?vue&type=style&index=0&id=02468d88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02468d88",
  null
  
)

export default component.exports